import { FC } from 'react'

import useWindowSize from './util/useWindowSize'
import { generateSrcSet } from 'project/image-proxy-web'

export type RatingsType = {}

export const Ratings: FC<RatingsType> = () => {
  const size = useWindowSize()
  return (
    <>
      {size.isLgOrHigher ? (
        <ul className='list-unstyled d-lg-flex gap-10 d-none mt-8 '>
          <li className='ms-0 ps-0'>
            <img
              {...generateSrcSet(
                '/images/logos/cyber-essentials-certified-plus.svg',
                72,
                57,
              )}
              loading='lazy'
              className='img-fluid'
              alt='LW Rating Icon'
              width={72}
              height={57}
            />
          </li>

          <li className='ms-0 ps-0'>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-ico-footer-icon-desktop.svg',
                94,
                55,
              )}
              loading='lazy'
              className='img-fluid'
              alt='ICO Rating Icon'
              width={94}
              height={55}
            />
          </li>
          <li className='ms-0 ps-0'>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-cloudflare-footer-icon-desktop.svg',
                101,
                62,
              )}
              loading='lazy'
              className='img-fluid'
              alt='SSL Icon'
              width={101}
              height={62}
            />
          </li>
        </ul>
      ) : (
        <ul className='list-unstyled d-flex gap-5 d-lg-none mt-8 mb-6 rating-logos mx-n4'>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/cyber-essentials.png',
                72,
                57,
              )}
              loading='lazy'
              className='img-fluid'
              alt='LW Rating Icon'
              width={72}
              height={57}
            />
          </li>

          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-ico-footer-icon-desktop.svg',
                95,
                56,
              )}
              loading='lazy'
              className='img-fluid'
              alt='ICO Rating Icon'
              width={95}
              height={56}
            />
          </li>
          <li>
            <img
              {...generateSrcSet(
                '/images/ratings/homepage-cloudflare-footer-icon-desktop.svg',
                101,
                62,
              )}
              loading='lazy'
              className='img-fluid'
              alt='SSL Icon'
              width={101}
              height={62}
            />
          </li>
        </ul>
      )}
    </>
  )
}

Ratings.displayName = 'Ratings'
export default Ratings
